export default {
	firstname: "First name",
	lastname: "Last name",
	phone: "Phone number",
	language: "Language",
	languageHint:
		"This is the language of the user interface, not the correspondence language. The correspondence language for documents and emails is set in the customer settings.",
	newsletterSubscribe: "Subscribe to newsletter",
	newsletterSubscribed:
		"Subscribed to the newsletter. If you wish, you can unsubscribe again with the next mailing.",
	usernameEmail: "Username / Email",
	changeUsernameTooltip:
		"Click here to change your email address / username. You will set the new username in a dialog box.",
	changePasswordButton: "Change password",
	changePasswordTooltip: "Click here to change your password.",
	appCodeLabel: "App code for Fusion 360 / SolidWorks Add-In",
	appCodeDescription:
		"If you design with Autodesk Fusion 360 or SolidWorks, we recommend using the Blexon Add-In. Install the add-in for {fusion} or {solidworks} and connect it with the app code above to Blexon Shop. This allows you to load your CAD models directly into Blexon Shop without exporting/importing.",
	appCodeSecrecy:
		"Keep your app code secret and never share it with third parties. If your app code has been exposed, be sure to generate a new one.",
	copyAppCode: "Copy",
	copyAppCodeTooltip: "Copy code to clipboard",
	regenerateAppCode: "Regenerate",
	regenerateAppCodeTooltip:
		"Click here to generate a new code. Access with the old code will then no longer be possible.",
	changeUsernameDialog: {
		title: "Change username",
		text: "Your email address is also your username for logging in.",
		text2: "If you change your email address, your username will also change. Please note this the next time you log in.",
		newUsernameLabel: "New username / Email",
		hint: "Note:",
		hintText:
			"This is not the email address used for invoice delivery. You will find that under invoice address settings.",
	},
	emailChangeRegisteredDialog: {
		title: "Confirmation email sent",
		text: "You will receive a confirmation email at the new address you provided.",
		text2: "Clicking the link it contains will activate the change.",
	},
	emailChangeFailedDialog: {
		title: "Change failed",
		text: "The change could not be completed.",
		text2: "Please check that the email address is correct and valid.",
		text3: "A Blexon account may already exist under this email address.",
		text4: "If you believe the new email address is valid and belongs to you, please contact our helpdesk.",
	},
	changePasswordDialog: {
		title: "Change password",
		text: "We will send you an email to {username}. It contains a code and a link to the page where you can set a new password using the code.",
		text2: "Please also check your spam folder if you don't receive the email.",
	},
	messages: {
		usernameSame:
			"The new username is identical to the current one or to one already requested.",
		saveSuccess: "Settings saved successfully.",
		saveError: "Settings could not be saved.",
		passwordChangeMailSent: "Password change email has been sent.",
		passwordChangeMailError: "Password change email could not be sent.",
		appCodeCopied: "App code copied to clipboard successfully.",
		appCodeGenerateError: "Error generating the app code. Please contact our helpdesk.",
	},
};
